import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useState} from "react";
import {
    GetPayoutDash,
} from "../../../redux/actions/GlobalAction"; //API Calling
import {
  clearCurrentPage,
  clearDuration,
  getApiParams,
  initialFilterPayout //initalVal
} from "./helper";
import PaginatedItems from "../../../common/Pagination";
import DateRangePickerInput from "../ProviderProfileDetails/DateRangePicker";
import Modal from "react-modal";
import { SearchIcon } from "../../../Utils/SvgIcons";
import{getToken} from "../../../Utils/types";
import {API_URL_WITHOUT_USER} from "../../../Utils/API";
export const PayoutDashboard = () => {
    const dispatch = useDispatch();
    const [providerName, setProviderName] = useState("");
    const [businessUnit, setBusinessUnit] = useState("ALL"); // Set a default value
    const [dateRange, setDateRange] = useState({ startDate: '2025-04-01T00:00:00', endDate: '2026-03-31T00:00:00' });
    const [RpTy, setRpTy] = useState("S");
    const [searchFilter, setSearchFilter] = useState(initialFilterPayout);
    const [provideridT, setprovideridT] = useState("");
    const payoutReducer = useSelector((state) => state?.PayoutReducer); //Reducer 
    const [isLoadingExcel, setIsLoadingExcel] = useState(false);
    
    const handleSearch = () => {
        const Dtperiod = document.getElementsByClassName('daterangeinput')[0].value;
        const startDate = dateRange.startDate;
        const endDate = dateRange.endDate;
        if (Dtperiod != null && Dtperiod != '')
        {
            const DtperiodSp = Dtperiod.split(' - ')
            const StdatePart = DtperiodSp[0].split('/');
            const eddatePart = DtperiodSp[1].split('/');
            startDate = StdatePart[2] + "-" + StdatePart[1] + "-" + StdatePart[0] +"T00:00:00";
            endDate = eddatePart[2] + "-" + eddatePart[1] + "-" + eddatePart[0] +"T00:00:00";
        }
                
        
        const CurFilter = ({
            ...searchFilter,
            page: 1,
            rows: 5000,
            Butype: businessUnit,
            UserId: 2013,
            StartDate: startDate ,
            EndDate: endDate,
            ProviderIds: providerName
        });
        setSearchFilter(CurFilter);
        dispatch(
            GetPayoutDash(CurFilter)
         //GetClientListNetwork({ clientId: 0, clientName: "", BusinessType: "CBU" })
        );
    };

    useEffect(() => {
        dispatch(GetPayoutDash({ ...searchFilter, page: 1 }));
      }, []);
    
    const handleProviderClick = (pid) => {
        setRpTy("T");    
        setprovideridT(pid);
        const DetailFilter = ({
            ...searchFilter,
            ProviderIds: String(pid),
            RpTy:"T"
        });
        dispatch(
            GetPayoutDash(DetailFilter)
         //GetClientListNetwork({ clientId: 0, clientName: "", BusinessType: "CBU" })
        );  
    }

    const downloadFile = (RptTy) => {
        setIsLoadingExcel(true);
        const url = `${API_URL_WITHOUT_USER}/NetworkPayout/ExportToExcelGetpayoutDashboard`;
        let pidT = providerName;
        if(RptTy === 'T') 
        {
            pidT = provideridT;
        }
        let data = {
          ...searchFilter,
          RpTy : RptTy,
          ProviderIds :String(pidT)  
        };
    
        fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: getToken(),
            MenuId: "",
          },
          body: JSON.stringify(data),
        })
          .then((response) => response.blob())
          .then((blob) => {
            const filename = "ProviderPayoutDetails.xlsx";
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            setIsLoadingExcel(false);
          })
          .catch((error) => {
            console.error("Failed to fetch the file");
            setIsLoadingExcel(false);
          });
    };

    const handleBack =() =>{
        setRpTy("S");
        dispatch(GetPayoutDash({ ...searchFilter,  RpTy:"S" }));
    }
           

return (
    <div className="right-section" style={{ padding: "20px" }}>
        <div className="card staff-details-section">
            <div className="card-body">
                {(RpTy === "S") ? ( <>
                    <h4> Payout OutLine </h4>
                    <div className="row-filter">
                        <input type="text" placeholder="Provider's Name/Id" className="white-form-select"
                            value={providerName}
                            onChange={(e) => setProviderName(e.target.value)}
                        />
                        <select className="white-form-select" 
                            value={businessUnit}
                            onChange={(e) => setBusinessUnit(e.target.value)}
                        >
                        <option value="ALL">ALL BU</option>
                        <option value="IBU">IBU</option>
                        <option value="CBU">CBU</option>
                        </select>
                        <DateRangePickerInput 
                            id ="idDtRg" 
                            value={setDateRange}
                        />                    
                        <div className="search" type="button" onClick={handleSearch}>
                            <a className="sidebar-links">
                                <SearchIcon />
                                <span className="sidebar-link-text">Search</span>
                            </a>
                        </div>
                        <button className="search" type="button" style={{ border: "none" }} >
                        <a className="sidebar-links">
                            <span className="sidebar-link-text">Clear All</span>
                        </a>
                        </button>
                        <button className="search" type="button" style={{ border: "none" }} 
                        onClick={() => downloadFile("S")}>
                        <a className="sidebar-links">
                            <span className="sidebar-link-text">Export To Excel</span>
                        </a>
                        </button>
                    </div>
                    <div className="row-results">
                        <div className="results">
                        Total <span>{payoutReducer?.PayoutDashDataReducer?.length || 0}</span> results
                        </div>
                    </div>                
                    <div className="table-responsive __custom__properties">
                        <table className="table" style={{ overflow: "hidden" }}>
                            <thead>
                            <tr>
                                <th scope="col">Provider</th>
                                <th scope="col">Total Amount</th>
                                <th scope="col">00 - 30</th>
                                <th scope="col">31 - 90</th>
                                <th scope="col">91 - 180</th>
                                <th scope="col">181 - 365</th>
                                <th scope="col">01 - 02 Yrs</th>
                                <th scope="col">02 - 03 Yrs</th>
                                <th scope="col">03+ Yrs</th>
                                <th scope="col">Adv. Amount</th>
                            </tr>
                            </thead>
                            <tbody>
                                {/* Conditional rendering based on API data */}
                                {payoutReducer?.PayoutDashDataReducer?.map((data, index) => (
                                        <tr key={index}>
                                            <td
                                                style={{ cursor: "pointer", color: "blue", textDecoration: "underline" }}
                                                onClick={() => handleProviderClick(data.providerId)}
                                            >{data.providerName} - {data.providerId}</td>
                                            <td style={{ textAlign: "right" }}>{data.totalGrossPending.toLocaleString('en-IN')}</td>
                                            <td style={{ textAlign: "right" }}>{data.total030.toLocaleString('en-IN')}</td>
                                            <td style={{ textAlign: "right" }}>{data.total3190.toLocaleString('en-IN')}</td>
                                            <td style={{ textAlign: "right" }}>{data.total91180.toLocaleString('en-IN')}</td>
                                            <td style={{ textAlign: "right" }}>{data.total181365.toLocaleString('en-IN')}</td>
                                            <td style={{ textAlign: "right" }}>{data.total0102yrs.toLocaleString('en-IN')}</td>
                                            <td style={{ textAlign: "right" }}>{data.total0203yrs.toLocaleString('en-IN')}</td>
                                            <td style={{ textAlign: "right" }}>{data.total03plusyrs.toLocaleString('en-IN')}</td>
                                            <td style={{ textAlign: "right" }}>{data.totaladvance.toLocaleString('en-IN')}</td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </table>
                    </div></>
                ):(
                    <>
                    <div>                 
                        <div className="back-buttondiv"onClick={handleBack} style={{ cursor: "pointer" }}>
                            <i className="fa-solid fa-circle-arrow-left"></i>
                            <h6>Back</h6>
                        </div>
                        <div className="back-buttondiv" onClick={() => downloadFile("T")} style={{ cursor: "pointer",float :"right" }}>
                            <i className="fa-solid fa-circle-arrow-down"></i>
                            <h6>Export To Excel</h6>
                        </div>
                        <h4>Transactions for Provider</h4>
                        <div className="row-results">
                            <div className="results" style={{width:"100%"}}>
                              {payoutReducer?.PayoutDashDataReducer?.length > 0 && (
                                <> <p>Provider: {payoutReducer.PayoutDashDataReducer[0].providerName}
                                   <span style={{float:"right"}}>Range: {payoutReducer.PayoutDashDataReducer[0].dateRange}</span>   
                                   </p>
                                   <p style={{float:"right"}} >
                                        <span style={{float:"right"}}>Opening Bal: {payoutReducer.PayoutDashDataReducer[0].totalOpening.toLocaleString('en-IN')}</span>
                                   </p>
                                </>
                                )}
                            </div>
                        </div>  
                        <div className="table-responsive __custom__properties">
                            <table className="table" style={{ overflow: "hidden" }}>
                                <thead>
                                <tr>
                                    <th scope="col">Month</th>
                                    <th scope="col">Description</th>
                                    <th scope="col">Ref Id</th>
                                    <th scope="col">Expenses</th>
                                    <th scope="col">Paymemt</th>                                    
                                </tr>
                                </thead>
                                <tbody>
                                    {/* Conditional rendering based on API data */}
                                    {payoutReducer?.PayoutDashDataReducer?.map((data, index) => (
                                            <tr key={index}>
                                                <td style={{ textAlign: "center" }}>{data.mnt}</td>
                                                <td style={{ textAlign: "left" }}>{data.desc}</td>
                                                <td style={{ textAlign: "left" }}>{data.refId}</td>
                                                <td style={{ textAlign: "right" }}>{data.expenses.toLocaleString('en-IN')}</td>
                                                <td style={{ textAlign: "right" }}>{data.payment.toLocaleString('en-IN')}</td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </table>
                        </div> 
                        <div className="row-results">
                            <div className="results" style={{width:"100%"}}>
                              {payoutReducer?.PayoutDashDataReducer?.length > 0 && (
                                <> <p style={{float:"right"}} >Closing Bal: {payoutReducer.PayoutDashDataReducer[0].totalClosing.toLocaleString('en-IN')}
                                   </p>
                                   
                                </>
                                )}
                            </div>
                        </div>                           
                    </div>
                    </>
                )}
            </div>    
        </div>
    </div>    
)
}